export default __webpack_public_path__ + "dist/media/Gallery.aa3e74f2.svg";